import { uid } from '@/utils/uid';

const defaultSchema = {
  inputs: {
    step1: {
      project_name: 'Project 1',
      project_location: '',
      climate_zone: ``,
      latitude: '',
      locationObj: ``, //{loc:'', climate:''}
      client_name: '',
      designed_by: '',
    },
    step2: {
      enable_surface_area_direct: false,
      surface_area_direct: 0,
      commonFields: {
        loading_factor: 25, //default

        no_of_floors: 0,
        floor_height: 0,
      },

      houseTypeArrObj: [
        {
          type: 'Type 1',
          house_categories: ['EWS', 'MIG', 'LIG', 'HIG'],
          selected_category: '',
          carpet_area: 0,
          // area_of_walls: 12,
          area_of_walls: 12,

          built_up_area: 0,
          no_of_du: 0,
        },
      ],
      summary_step2: {
        area_floor_plate: 0,
        total_built_up_area: 0,
        wall_cross_sectional_area: 0,
        surface_area_wall: 0,
      },
    },
    step3A: {
      wallSurfaceAreaArrObj: [
        {
          wallOrientation: 'N',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 0.57,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'NE',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 0.91,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'E',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 1.16,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'SE',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 1.13,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'S',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 0.97,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'SW',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 1.12,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'W',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 1.16,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
        {
          wallOrientation: 'NW',
          orientationSurfaceArea: 0,
          calcWallArea: 0,
          orientationFactor: 0.91,
          abcWalls: 0,
          uValueWall: 0,
          selectedTransWall: ``,
        },
      ],
      summary: {
        total_wall_percent: 0,
        total_wall_surface_area: 0,
        total_abc_wall: 0,
      },
    },
    step3B: {
      wwrWindowArrObj: [
        {
          windowOrientation: 'N',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'NE',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'E',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'SE',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'S',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'SW',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'W',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
        {
          windowOrientation: 'NW',
          windowOrientationWwr: 0,
          calcWindowOpeningArea: 0.0,
        },
      ],
      total_opening_area: 0,
      window_types_data: [
        { type: 'Openable Shutter', openablePercent: 90 },
        { type: 'Fixed', openablePercent: 0 },
        { type: 'Sliding-2 pane', openablePercent: 50 },
        { type: 'Sliding-3 pane', openablePercent: 67 },
      ],
      windowTypeArrObj: [
        {
          window_serial: 'W1',
          window_type: '', //gets object {type:'',openablePercent:''}
          // window_openable_percent:0,
          input_glass_percent: 0,
          opaque_percent: 0,
          all_orient_openable_area: 0,
          all_orient_glass_area: 0,
          all_orient_opaque_area: 0,

          orientationObj: [
            {
              orientation: 'N',
              inputOrientationPercent: 0,
              calcOpenableArea: 0,
              checkedOpenableArea: 'false',
              calcGlassArea: 0,
              calcOpaqueArea: 0,
              orientFactor: 0.57,
              uValueNonOpaque: 0,
              selectedNonOpaqueMaterial: ``,
              abcNonOpaqueWindow: 0,
              selectedShading: '',
              shgcEff: 0,
              abcSHGCWindow: 0,
            },

            { orientation: 'NE', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.91, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'E', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.16, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'SE', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.13, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'S', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.97, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'SW', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.12, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'W', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.16, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
            { orientation: 'NW', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.91, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0, selectedShading: '', shgcEff: 0, abcSHGCWindow: 0 },
          ],
        },
      ],
      summary_window_type: {
        total_n_orient: 0,
        total_ne_orient: 0,
        total_e_orient: 0,
        total_se_orient: 0,
        total_s_orient: 0,
        total_sw_orient: 0,
        total_w_orient: 0,
        total_nw_orient: 0,
      },
      summary_window_openable: {
        total_openable_area: 0,
      },
      summary_window_glass: {
        total_glass_area: 0,
      },
      summary_window_opaque: {
        total_opaque_area: 0,
      },
    },
    // Ventilator & Door Openable Area
    step3C: {
      ventilatorArrObj: [
        {
          orientation: 'N',
          inputWwrOrientationPercent: 0,
          calcOpeningArea: 0,
          calcGlassArea: 0,
          calcOpenableArea: 0,
          checkedOpenableArea: 'false',
          selectedGlassMaterial: ``,
          uValueMaterial: 0,
          orientFactor: 0.57,
          abcVentilator: 0,
          abcSHGCVentilator: 0,
          selectedShading: ``,
          shgcEff: 0,
        },
        { orientation: 'NE', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 0.91, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'E', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 1.16, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'SE', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 1.13, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'S', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 0.97, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'SW', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 1.12, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'W', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 1.16, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
        { orientation: 'NW', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcGlassArea: 0, calcOpeningArea: 0, selectedGlassMaterial: ``, uValueMaterial: 0, orientFactor: 0.91, abcVentilator: 0, shgcEff: 0, abcSHGCVentilator: 0, selectedShading: `` },
      ],
      summary_ventilator_openable: {
        total_opening_area: 0,
        total_glass_area: 0,
        total_openable_area: 0,
        total_abc_ventilator: 0,
        total_abc_shgc_ventilator: 0,
      },
      doorArrObj: [
        {
          orientation: 'N',
          inputWwrOrientationPercent: 0,
          calcOpeningArea: 0,
          calcOpaqueArea: 0,
          calcOpenableArea: 0,
          checkedOpenableArea: 'false',
          uValueDoor: 0,
          orientationFactor: 0.57,
          selectedTransDoor: ``,
          abcDoor: 0,
        },
        { orientation: 'NE', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 0.91, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'E', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 1.16, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'SE', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 1.13, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'S', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 0.97, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'SW', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 1.12, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'W', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 1.16, abcDoor: 0, selectedTransDoor: `` },
        { orientation: 'NW', inputWwrOrientationPercent: 0, calcOpenableArea: 0, checkedOpenableArea: 'false', calcOpaqueArea: 0, calcOpeningArea: 0, uValueDoor: 0, orientationFactor: 0.91, abcDoor: 0, selectedTransDoor: `` },
      ],
      summary_door_openable: {
        total_opening_area: 0,
        total_opaque_area: 0,
        total_openable_area: 0,
        total_abc_door: 0,
      },
    },
    step4: {
      wfropObj: {
        total_openable_area: 0,
        total_carpet_area: 0,
        wfropPercent: 0,
        minWfropPercent: 0,
      },
      vltObj: {
        window_wall_ratio: 0,
        required_vlt: 0,
      },
    },
    step5A: {
      thermal_trans_roof: [
        {
          layer: 'Layer 1',
          material: '',
          thermal_resistance: 0,
          material_n_resistance: '', //{material:'',thermal_resistance:''}
        },
      ],
      total_thermal_resistance: 0,
      roof_u_value: 0,
    },
    step5B: {
      thermal_trans_walls: [
        {
          wall: `Wall 1`,
          layer_arr_obj: [
            {
              layer: 'Layer 1',
              material: '',
              thermal_resistance: 0,
              material_n_resistance: '', //{material:'',thermal_resistance:''}
            },
          ],
          total_thermal_resistance: 0,
          u_value_wall: 0,
        },
      ],
      thermal_trans_doors: [
        {
          door: `Door 1`,
          layer_arr_obj: [
            {
              layer: 'Layer 1',
              material: '',
              thermal_resistance: 0,
              material_n_resistance: '', //{material:'',thermal_resistance:''}
            },
          ],
          total_thermal_resistance: 0,
          u_value_door: 0,
        },
      ],

      thermal_trans_windows: [
        {
          window: `Window 1`,
          layer_arr_obj: [
            {
              layer: 'Layer 1',
              material: '',
              thermal_resistance: 0,
              material_n_resistance: '', //{material:'',thermal_resistance:''}
            },
          ],
          total_thermal_resistance: 0,
          u_value_window: 0,
        },
      ],
    },
    retv6A: {
      retvWindowArrObj: [
        { orient: 'N', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 0.57, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'NE', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 0.91, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'E', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 1.16, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'SE', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 1.13, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'S', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 0.97, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'SW', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 1.12, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'W', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 1.16, abcWindowOpaque: 0, selectedConstruction: `` },
        { orient: 'NW', orientOpaqueArea: 0, uValueWindow: 0, orientFactor: 0.91, abcWindowOpaque: 0, selectedConstruction: `` },
      ],
      summary_retv6A: {
        total_abc_window: 0,
        term_1_total: 0,
      },
    },
    retv6B: {
      windowNonOpaqueArrObj: [],
      summary_retv6B: {
        total_abc_non_opaque_window: 0,
        // total_abc_non_opaque_ventilator: 0, //in step3C summary
        term_2_total: 0,
      },
    },
    retv6C: {
      total_abc_window: 0,
      total_abc_ventilator: 0,
      total_shgcEff_window: 0,
      avg_shgcEff_window: 0,
      total_shgcEff_venti: 0,
      term_3_total: 0,
      retv: 0,
    },
  },
  wallConstructionAssemblyData: [],
  glazingSelectionData: [],
  windowShadingData: [],
  ventiShadingData: [],
  shadingSelectionData: [],
};

const defaultProject = {
  project_name: 'Project 1',
  project_icon: 'light-icon-stack',
  project_path: 'project-1',
  project_index: 1,
  schema: JSON.parse(JSON.stringify(defaultSchema)),
};

const defaultShadings = [
  //No shading
  {
    id: uid().substr(0, 4), //
    type: `No Shading`,
    title: 'No shading',
    overhangV: 1,
    overhangH: 1,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 1,
    shgcEquiv: {
      N: [
        [0.0], //Lat1 >=23.5
        [0.0], //Lat2 <23.5
      ],
      NE: [[0.0], [0.0]],
      E: [[0.0], [0.0]],
      SE: [[0.0], [0.0]],
      S: [[0.0], [0.0]],
      SW: [[0.0], [0.0]],
      W: [[0.0], [0.0]],
      NW: [[0.0], [0.0]],

      // ],
    },
  },
  //Horizontal
  {
    id: uid().substr(0, 4), //
    type: 'Horizontal Overhang',
    title: `Horizontal Overhang-550(H)-1200(V)`,
    overhangV: 1200,
    overhangH: 550,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.88], //Lat1 >=23.5
        [0.84], //Lat2 <23.5
      ],

      NE: [[0.8], [0.78]],

      E: [[0.75], [0.75]],
      SE: [[0.7], [0.72]],
      S: [[0.67], [0.71]],
      SW: [[0.7], [0.72]],
      W: [[0.74], [0.75]],
      NW: [[0.8], [0.78]],
    },
  },
  //Balcony 1000mm overhang, h-2100mm
  {
    id: uid().substr(0, 4), //
    type: 'Balcony-3side-open',
    title: `Balcony dept-1000(H)-2100(V)`,
    overhangV: 2100,
    overhangH: 1000,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.88], //Lat1 >=23.5
        [0.84], //Lat2 <23.5
      ],

      NE: [[0.8], [0.78]],

      E: [[0.75], [0.75]],
      SE: [[0.7], [0.72]],
      S: [[0.67], [0.71]],
      SW: [[0.7], [0.72]],
      W: [[0.74], [0.75]],
      NW: [[0.8], [0.78]],
    },
  },
  //Vertical 600mm fin, Left, V-1500mm
  {
    id: uid().substr(0, 4), //
    type: 'Vertical fin(L)',
    title: `Vertical fin-600(H)-1500(V)`,
    overhangV: 1500,
    overhangH: 600,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.91], //Lat1 >=23.5
        [0.9], //Lat2 <23.5
      ],

      NE: [[0.95], [0.95]],
      E: [[0.96], [0.95]],
      SE: [[0.88], [0.87]],
      S: [[0.9], [0.9]],
      SW: [[0.95], [0.95]],
      W: [[0.92], [0.92]],
      NW: [[0.83], [0.84]],
    },
  },
  //Balcony 1200mm overhang, h-2100mm
  {
    id: uid().substr(0, 4), //
    type: 'Balcony-3side-open',
    title: `Balcony-1200(H)-2100(V)
    `,
    overhangV: 2100,
    overhangH: 1200,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.86], //Lat1 >=23.5
        [0.82], //Lat2 <23.5
      ],

      NE: [[0.78], [0.76]],

      E: [[0.7], [0.71]],
      SE: [[0.65], [0.68]],
      S: [[0.63], [0.68]],
      SW: [[0.65], [0.68]],
      W: [[0.7], [0.71]],
      NW: [[0.78], [0.76]],
    },
  },
  //Horizontal overhang 600mm, Vertical fins 600mm
  {
    id: uid().substr(0, 4), //
    type: 'Combination',
    title: `Combination-overhang-600(H)-1200(V)-Vertical fins-600(H)-1200(V)`,
    // Combination-overhang-600(H)-1200(V)-Vertical fins-600(H)-1200(V)

    overhangV: 1200,
    overhangH: 600,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.69], //Lat1 >=23.5
        [0.64], //Lat2 <23.5
      ],

      NE: [[0.58], [0.57]],

      E: [[0.6], [0.61]],
      SE: [[0.53], [0.54]],
      S: [[0.48], [0.52]],
      SW: [[0.53], [0.54]],
      W: [[0.39], [0.6]],
      NW: [[0.58], [0.57]],
    },
  },

  //Horizontal 550mm overhang, h-1900mm
  {
    id: uid().substr(0, 4), //
    type: 'Horizontal Overhang',
    title: `Horizontal Overhang-550(H)-1900(V) `,
    overhangV: 1900,
    overhangH: 550,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.92], //Lat1 >=23.5
        [0.89], //Lat2 <23.5
      ],

      NE: [[0.88], [0.86]],

      E: [[0.86], [0.86]],
      SE: [[0.82], [0.83]],
      S: [[0.79], [0.82]],
      SW: [[0.82], [0.83]],
      W: [[0.58], [0.58]],
      NW: [[0.88], [0.86]],
    },
  },

  //3-Side Covered Balcony 1100mm overhang-ECBC
  {
    id: uid().substr(0, 4), //
    type: 'Balcony-2side-covered',
    title: `Balcony-2side-covered-Overhang-1100(H)-430(V)-Vertical(L)-1100(H)-800(V)-R=Vertical(R)-1100(H)-1750(V)-ECBC
    `,
    overhangV: 1100,
    overhangH: 430,
    overhangLeftV: 800,
    overhangLeftH: 1100,
    overhangRightV: 1750,
    overhangRightH: 1100,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.61], //Lat1 >=23.5
        [0.56], //Lat2 <23.5
      ],

      NE: [[0.51], [0.49]],

      E: [[0.47], [0.47]],
      SE: [[0.4], [0.43]],
      S: [[0.42], [0.45]],
      SW: [[0.42], [0.44]],
      W: [[0.29], [0.47]],
      NW: [[0.49], [0.47]],
    },
  },

  //Horizontal overhang 400mm, Vertical fins 400mm-ECBC

  {
    id: uid().substr(0, 4), //
    type: 'Combination',
    title: `Combination-Overhang-400(H)-530(V)-Vertical(L-R)-400(H)-1200(V)-ECBC
    `,
    overhangV: 530,
    overhangH: 400,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.71], //Lat1 >=23.5
        [0.65], //Lat2 <23.5
      ],

      NE: [[0.61], [0.59]],

      E: [[0.57], [0.57]],
      SE: [[0.51], [0.54]],
      S: [[0.48], [0.52]],
      SW: [[0.51], [0.53]],
      W: [[0.57], [0.57]],
      NW: [[0.61], [0.59]],
    },
  },

  //Horizontal overhang 470mm-ECBC

  {
    id: uid().substr(0, 4), //
    type: 'Horizontal Overhang',
    title: `Horizontal Overhang-500(H)-1200(V) 
    `,
    overhangV: 500,
    overhangH: 1200,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.88], //Lat1 >=23.5
        [0.84], //Lat2 <23.5
      ],

      NE: [[0.83], [0.78]],

      E: [[0.8], [0.75]],
      SE: [[0.76], [0.72]],
      S: [[0.67], [0.71]],
      SW: [[0.7], [0.72]],
      W: [[0.79], [0.75]],
      NW: [[0.83], [0.78]],
    },
  },
  //Horizontal 500mm overhang, h-1200mm
  {
    id: uid().substr(0, 4), //
    type: 'Horizontal Overhang',
    title: `Horizontal Overhang-450(H)-1200(V)`,
    overhangV: 1200,
    overhangH: 450,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.9], //Lat1 >=23.5
        [0.86], //Lat2 <23.5
      ],

      NE: [[0.88], [0.82]],

      E: [[0.86], [0.8]],
      SE: [[0.82], [0.77]],
      S: [[0.72], [0.75]],
      SW: [[0.75], [0.77]],
      W: [[0.58], [0.8]],
      NW: [[0.88], [0.82]],
    },
  },
  //Horizontal 450mm overhang, h-1200mm

  {
    id: uid().substr(0, 4), //
    type: 'Balcony-1side-covered',
    title: `Balcony-1-side-covered-Left-Overhang-600(H)-1200(V)-Vertical(R)-400(H)-900(V)
    `,
    overhangV: 1200,
    overhangH: 600,
    overhangLeftV: 0,
    overhangLeftH: 0,
    overhangRightV: 900,
    overhangRightH: 400,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.78], //Lat1 >=23.5
        [0.74], //Lat2 <23.5
      ],

      NE: [[0.64], [0.63]],

      E: [[0.64], [0.65]],
      SE: [[0.62], [0.65]],
      S: [[0.56], [0.6]],
      SW: [[0.57], [0.59]],
      W: [[0.67], [0.67]],
      NW: [[0.74], [0.72]],
    },
  },
  {
    id: uid().substr(0, 4), //
    type: 'Balcony-1side-covered',
    title: `Balcony-1-side-covered-Right-Overhang-600(H)-1200(V)-Vertical(L)-450(H)-850(V)`,
    overhangV: 1200,
    overhangH: 600,
    overhangLeftV: 850,
    overhangLeftH: 450,
    overhangRightV: 0,
    overhangRightH: 0,
    overhangPF: 0,
    shgcEquiv: {
      N: [
        [0.74], //Lat1 >=23.5
        [0.7], //Lat2 <23.5
      ],

      NE: [[0.72], [0.69]],

      E: [[0.65], [0.64]],
      SE: [[0.53], [0.54]],
      S: [[0.54], [0.58]],
      SW: [[0.6], [0.63]],
      W: [[0.61], [0.62]],
      NW: [[0.57], [0.57]],
    },
  },
];

export { defaultSchema, defaultProject, defaultShadings };
